import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from 'components/BaseComponent';

import { selectWorks } from '../../Api/selectors';
import { HBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { EditSquare, Sync } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { VehicleActionActivator } from '../components/SimulatedVehicleTask';
import { KanbanColumnFilter } from '../components/ColumnFilter';
import { forceKanbanCacheRefresh } from '../actions';
import { REQUEST_KANBAN_BOARD_COLUMN_CELLS } from '../constants';
import { selectKanbanBoardColumnDirty } from '../selectors';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './columnHeader.module.css';
import { OnMouseOverNotification } from '../../Vehicles/components/OnMouseOverNotification';

const Header = styled.div`
  margin: -6px -6px 6px -6px;
  padding: 12px;
  font-weight: bold;
  background-color: #f0f1f9;
  border: 1px solid #e0e1eb;
  border-bottom: none;
  color: #808185;
  font-size: 14px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 5px;
  .buttons {
    width: 130px;
    .button {
      margin: 0 2px;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class KanbanBoardColumnHeaderComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  get altText() {
    let altText = null;
    // if (true) {
    //   // altText = `${this.props.column?.label} Free Text...`;
    //   altText = this.props.column?.label;
    // }
    if (true && this.props.column?.label == 'Nationaal uitgaand') {
      altText =
        'Transport is aangevraagd\n' +
        'Transportlocatie is NL\n' +
        'Voertuig is WEL gelabeld\n' +
        'Uitgaande factuur is gefinaliseerd';
    }

    if (true && this.props.column?.label == 'Nationaal inkomend') {
      altText =
        'Transport is aangevraagd\n' +
        'Transportlocatie is NL\n' +
        'Voertuig is NIET gelabeld\n' +
        'Is beschikbaar (Datum verwacht)\n' +
        'Ophaalbericht crediteur niet verplicht';
    }

    if (true && this.props.column?.label == 'Factureren akkoord') {
      altText =
        'Debiteur is goedgekeurd\n\n' +
        'Als import en verkopen met kenteken, schades repareren:\n' +
        'Inkoopfactuur is toegevoegd\n' +
        'Inkoopfactuur is verwerkt\n' +
        'Eindinspectie is afgerond of is al opgehaald\n' +
        'Heeft een kenteken\n' +
        'Import BPM factuur is verwerkt\n\n' +
        'Als import en verkopen met kenteken, schades niet repareren:\n' +
        'Inkoopfactuur is toegevoegd\n' +
        'Inkoopfactuur is verwerkt\n' +
        'Heeft een kenteken\n' +
        'Import BPM factuur is verwerkt\n\n' +
        'Export met kenteken\n' +
        'Inkoopfactuur is toegevoegd\n' +
        'Inkoopfactuur is verwerkt\n' +
        'Export BPM factuur is verwerkt\n' +
        'Import BPM factuur is verwerkt\n\n' +
        'Export zonder kenteken\n' +
        'Inkoopfactuur is toegevoegd\n' +
        'Inkoopfactuur is verwerkt\n\n' +
        'Als schades repareren en zonder kenteken verkopen\n' +
        'Inkoopfactuur is toegevoegd\n' +
        'Inkoopfactuur is verwerkt\n' +
        'Eindinspectie is afgerond of is al opgehaald\n\n' +
        'Als zonder schades repareren en zonder kenteken verkopen\n' +
        'Inkoopfactuur is toegevoegd\n' +
        'Inkoopfactuur is verwerkt';
    }

    if (true && this.props.column?.label == 'Factureren niet akkoord') {
      altText =
        '<b>Debiteur is NIET goedgekeurd</b>\n\n' +
        'Als import en verkopen met kenteken, schades repareren:\n' +
        'Inkoopfactuur is toegevoegd\n' +
        'Inkoopfactuur is verwerkt\n' +
        'Eindinspectie is afgerond of is al opgehaald\n' +
        'Heeft een kenteken\n' +
        'Import BPM factuur is verwerkt\n\n' +
        'Als import en verkopen met kenteken, schades niet repareren:\n' +
        'Inkoopfactuur is toegevoegd\n' +
        'Inkoopfactuur is verwerkt\n' +
        'Heeft een kenteken\n' +
        'Import BPM factuur is verwerkt\n\n' +
        'Export met kenteken\n' +
        'Inkoopfactuur is toegevoegd\n' +
        'Inkoopfactuur is verwerkt\n' +
        'Export BPM factuur is verwerkt\n' +
        'Import BPM factuur is verwerkt\n\n' +
        'Export zonder kenteken\n' +
        'Inkoopfactuur is toegevoegd\n' +
        'Inkoopfactuur is verwerkt\n\n' +
        'Als schades repareren en zonder kenteken verkopen\n' +
        'Inkoopfactuur is toegevoegd\n' +
        'Inkoopfactuur is verwerkt\n' +
        'Eindinspectie is afgerond of is al opgehaald\n\n' +
        'Als zonder schades repareren en zonder kenteken verkopen\n' +
        'Inkoopfactuur is toegevoegd\n' +
        'Inkoopfactuur is verwerkt';
    }

    if (true && this.props.column?.label == '1') {
      altText = 'Factuur is betaald, transport kan gepland worden';
    }
    return altText;
  }

  render() {
    return (
      <Header className={styles.headerContainer}>
        {this.props.work || this.props.isDirty ? <Loader small /> : null}
        {this.props.label}
        {this.altText && <OnMouseOverNotification left={'40px'} top={'-70px'} iconColor={'grey'} message={this.altText} />}
        <HBox right className="buttons gap-2">
          <KanbanColumnFilter
            action={this.props.action}
            actionClass={this.props.actionClass}
            board_id={this.props.board_id}
            column={this.props.column}
          />
          <ButtonComponent
            size={'btn-sm'}
            style={'ButtonSoftPrimary'}
            onClick={this.props.forceCacheRefresh}
            disabled={this.props.work || this.props.isDirty}
          >
            <Sync />
          </ButtonComponent>
          {!this.props.isCompanyAction && (
            <VehicleActionActivator
              action={this.props.action}
              actionClass={this.props.actionClass}
              board_id={this.props.board_id}
              column={this.props.column}
              loggedUserId={this.props.loggedUserId}
              payload={this.props.payload}
              onChange={this.props.onChange}
            />
          )}
        </HBox>
      </Header>
    );
  }
}

KanbanBoardColumnHeaderComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_COLUMN_CELLS}${ownProps.board_id}_${ownProps.column.id}`]),
    isDirty: selectKanbanBoardColumnDirty(ownProps.board_id, ownProps.column.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    forceCacheRefresh() {
      dispatch(forceKanbanCacheRefresh(ownProps.board_id, ownProps.column.id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanBoardColumnHeader = compose(withConnect, withRouter)(KanbanBoardColumnHeaderComp);
